import { Typography, Box, Button, CircularProgress } from "@mui/material";
import Layout from "../components/Layout";

import { useSitesPage } from "../hooks/useSitesPage";
import { useTransferForm } from "../hooks/useTransferForm";

import { SitesFilterBar } from "../components/sites/SitesFilterBar";
import { SitesTable } from "../components/sites/SitesTable";
import { SiteDialog } from "../components/sites/SiteDialog";
import { DeleteConfirmDialog } from "../components/sites/DeleteConfirmDialog";
import { TransferDialog } from "../components/sites/transfer/TransferDialog";
import { SupplierFormDialog } from "../components/sites/transfer/SupplierFormDialog";
import { DailyOperationDialog } from "../components/sites/transfer/DailyOperationDialog";
import { FinishedProjectDialog } from "../components/sites/transfer/FinishedProjectDialog";
import { ProductSalesDialog } from "../components/sites/transfer/ProductSalesDialog";


export default function Sites() {
  const sites = useSitesPage();
  const transfer = useTransferForm({
    rows: sites.rows,
    products: sites.products,
    fetchSites: sites.fetchSites,
  });

  const transferTypeLabels = {
    supplier: "供應商來貨",
    daily_operation: "日常消耗",
    finished_project: "盤點",
    product_sales: "賣貨",
    transfer: "貨物內運申請",
  };

  const supplierList = [
    "CMP Tianjin Co., Ltd",
    "Fosroc Hong Kong Ltd.",
    "GYPSO ESG Technologies Limited",
    "Mapei China Ltd",
    "Pentens(H.K.) Limited",
    "Score Building Materials Ltd.",
    "Tech Link Construction Engineering Limited",
    "Tremco CPG Hong Kong Limited",
    "Y.C. Technology Co., Ltd.",
    "Yip's Camel (Hong Kong) Limited",
    "佛山市南海區閻氏磨料經營部",
    "展辰新材料有限公司",
    "超誠建築材料倉有限公司",
  ]

  const handleOpenTransferDialog = (type) => {
    transfer.openDialog(type);
  };

  return (
    <Layout>
      <Typography variant="h5" mb={2} sx={{ pl: 1 }}>
        地盤列表
      </Typography>

      {/* Top buttons */}
      <Box sx={{ display: "flex", gap: 2, mb: 2, pl: 1, flexWrap: "wrap" }}>
        {sites.role === "admin" && (
          <Button
            variant="contained"
            onClick={() => sites.openSiteDialog(null)}
          >
            新增地盤
          </Button>
        )}

        {sites.role === "admin" && (
          <Button
            variant="contained"
            onClick={() => handleOpenTransferDialog("supplier")}
          >
            供應商來貨
          </Button>
        )}

        <Button
          variant="contained"
          onClick={() => handleOpenTransferDialog("daily_operation")}
        >
          日常消耗
        </Button>

        {(sites.role === "admin" || sites.role === "staff_level_2") && (
          <Button
            variant="contained"
            onClick={() => handleOpenTransferDialog("finished_project")}
          >
            盤點
          </Button>
        )}

        {(sites.role === "admin" || sites.role === "staff_level_2") && (
          <Button
            variant="contained"
            onClick={() => handleOpenTransferDialog("product_sales")}
          >
            賣貨
          </Button>
        )}

        {(sites.role === "admin" || sites.role === "staff_level_2") && (
          <Button
            variant="contained"
            onClick={() => handleOpenTransferDialog("transfer")}
          >
            貨物內運申請
          </Button>
        )}
      </Box>

      {/* Filters + Table (hidden for staff_level_1) */}
      {sites.role !== "staff_level_1" && (
        <>
          <SitesFilterBar
            searchText={sites.searchText}
            setSearchText={sites.setSearchText}
            filterCompany={sites.filterCompany}
            setFilterCompany={sites.setFilterCompany}
            filterStatus={sites.filterStatus}
            setFilterStatus={sites.setFilterStatus}
            companies={sites.companies}
            onSearch={sites.applyFilter}
            onReset={sites.resetFilter}
          />

          {sites.loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Box>
          ) : (
            <SitesTable
              rows={sites.rows}
              loading={sites.loading}
              role={sites.role}
              userId={sites.userId}
              onEdit={(row) => sites.openSiteDialog(row)}
              onDelete={(id) => sites.setDeleteId(id)}
            />
          )}
        </>
      )}

      {/* Site Dialog */}
      <SiteDialog
        open={sites.siteDialogOpen}
        onClose={() => sites.setSiteDialogOpen(false)}
        form={sites.siteForm}
        setForm={sites.setSiteForm}
        companies={sites.companies}
        onSubmit={sites.saveSite}
        isEditing={!!sites.siteDialogOpen && !!sites.editingSiteId}
      />
      {transfer.transferForm && transfer.transferForm.transfer_type == "supplier" && (
        <SupplierFormDialog
          open={transfer.open}
          onClose={transfer.closeDialog}
          transferTypeLabels={transferTypeLabels}
          users={sites.users}
          transferForm={transfer.transferForm}
          setTransferForm={transfer.setTransferForm}
          submitting={transfer.submitting}
          error={transfer.error}
          setError={transfer.setError}
          siteOptions={transfer.siteOptions}
          fromSiteOptionsFiltered={transfer.fromSiteOptionsFiltered}
          toSiteOptionsFiltered={transfer.toSiteOptionsFiltered}
          getProductCatalogOptions={transfer.getProductCatalogOptions}
          getProductOptions={transfer.getProductOptions}
          addTransferItem={transfer.addTransferItem}
          removeTransferItem={transfer.removeTransferItem}
          updateTransferItem={transfer.updateTransferItem}
          showFromSite={transfer.showFromSite}
          showToSite={transfer.showToSite}
          showRestFields={transfer.showRestFields}
          renderDateLabel={transfer.renderDateLabel}
          submitTransfer={transfer.submitTransfer}
          handleSiteChange={transfer.handleSiteChange}
          supplierList = {supplierList}
        />
      )}

      {transfer.transferForm && transfer.transferForm.transfer_type == "daily_operation" && (
        <DailyOperationDialog
          open={transfer.open}
          onClose={transfer.closeDialog}
          transferTypeLabels={transferTypeLabels}
          users={sites.users}
          transferForm={transfer.transferForm}
          setTransferForm={transfer.setTransferForm}
          submitting={transfer.submitting}
          error={transfer.error}
          setError={transfer.setError}
          siteOptions={transfer.siteOptions}
          fromSiteOptionsFiltered={transfer.fromSiteOptionsFiltered}
          toSiteOptionsFiltered={transfer.toSiteOptionsFiltered}
          getProductCatalogOptions={transfer.getProductCatalogOptions}
          getProductOptions={transfer.getProductOptions}
          addTransferItem={transfer.addTransferItem}
          removeTransferItem={transfer.removeTransferItem}
          updateTransferItem={transfer.updateTransferItem}
          showFromSite={transfer.showFromSite}
          showToSite={transfer.showToSite}
          showRestFields={transfer.showRestFields}
          renderDateLabel={transfer.renderDateLabel}
          submitTransfer={transfer.submitTransfer}
          handleSiteChange={transfer.handleSiteChange}
        />
      )}
      {transfer.transferForm && transfer.transferForm.transfer_type == "finished_project" && (
        <FinishedProjectDialog
          open={transfer.open}
          onClose={transfer.closeDialog}
          transferTypeLabels={transferTypeLabels}
          users={sites.users}
          transferForm={transfer.transferForm}
          setTransferForm={transfer.setTransferForm}
          submitting={transfer.submitting}
          error={transfer.error}
          setError={transfer.setError}
          siteOptions={transfer.siteOptions}
          fromSiteOptionsFiltered={transfer.fromSiteOptionsFiltered}
          toSiteOptionsFiltered={transfer.toSiteOptionsFiltered}
          getProductCatalogOptions={transfer.getProductCatalogOptions}
          getProductOptions={transfer.getProductOptions}
          addTransferItem={transfer.addTransferItem}
          removeTransferItem={transfer.removeTransferItem}
          updateTransferItem={transfer.updateTransferItem}
          showFromSite={transfer.showFromSite}
          showToSite={transfer.showToSite}
          showRestFields={transfer.showRestFields}
          renderDateLabel={transfer.renderDateLabel}
          submitTransfer={transfer.submitTransfer}
          handleSiteChange={transfer.handleSiteChange}
        />
      )}
      {transfer.transferForm
        && transfer.transferForm.transfer_type == "transfer"
        && (
          <TransferDialog
            open={transfer.open}
            onClose={transfer.closeDialog}
            transferTypeLabels={transferTypeLabels}
            users={sites.users}
            transferForm={transfer.transferForm}
            setTransferForm={transfer.setTransferForm}
            submitting={transfer.submitting}
            error={transfer.error}
            setError={transfer.setError}
            siteOptions={transfer.siteOptions}
            fromSiteOptionsFiltered={transfer.fromSiteOptionsFiltered}
            toSiteOptionsFiltered={transfer.toSiteOptionsFiltered}
            getProductCatalogOptions={transfer.getProductCatalogOptions}
            getProductOptions={transfer.getProductOptions}
            addTransferItem={transfer.addTransferItem}
            removeTransferItem={transfer.removeTransferItem}
            updateTransferItem={transfer.updateTransferItem}
            showFromSite={transfer.showFromSite}
            showToSite={transfer.showToSite}
            showRestFields={transfer.showRestFields}
            renderDateLabel={transfer.renderDateLabel}
            submitTransfer={transfer.submitTransfer}
            handleSiteChange={transfer.handleSiteChange}
          />
        )}

      {transfer.transferForm
        && transfer.transferForm.transfer_type == "product_sales"
        && (
          <ProductSalesDialog
            open={transfer.open}
            onClose={transfer.closeDialog}
            transferTypeLabels={transferTypeLabels}
            users={sites.users}
            transferForm={transfer.transferForm}
            setTransferForm={transfer.setTransferForm}
            submitting={transfer.submitting}
            error={transfer.error}
            setError={transfer.setError}
            siteOptions={transfer.siteOptions}
            fromSiteOptionsFiltered={transfer.fromSiteOptionsFiltered}
            toSiteOptionsFiltered={transfer.toSiteOptionsFiltered}
            getProductCatalogOptions={transfer.getProductCatalogOptions}
            getProductOptions={transfer.getProductOptions}
            addTransferItem={transfer.addTransferItem}
            removeTransferItem={transfer.removeTransferItem}
            updateTransferItem={transfer.updateTransferItem}
            showFromSite={transfer.showFromSite}
            showToSite={transfer.showToSite}
            showRestFields={transfer.showRestFields}
            renderDateLabel={transfer.renderDateLabel}
            submitSales={transfer.submitSales}
            handleSiteChange={transfer.handleSiteChange}
          />
        )}

      {/* Delete Confirm */}
      <DeleteConfirmDialog
        deleteId={sites.deleteId}
        onClose={() => sites.setDeleteId(null)}
        onConfirm={sites.deleteSite}
      />
    </Layout>
  );
}
